import React from 'react'
import MaskInput from './MaskInput'


export interface MaskInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
}


export default function CardInput(props: MaskInputProps ) {
    return (
     <MaskInput mask={'________________'} replacement={{ _: /\d/ }}  {...props} />
    )
}